import { DropIndicator } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/tree-item';
import type {Instruction} from "@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item";


export type TreeDropIndicatorProps = {
    instruction: Instruction;
};

export const TreeDropIndicator = ({ instruction }: TreeDropIndicatorProps) => {
    if (instruction.type === 'instruction-blocked' && instruction.desired.type === 'make-child') {
        /* we don't show blocked indicator at all */
        return null;
    }
    return <DropIndicator instruction={instruction}/>
}